import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./styles.css";

function Home() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <section className="hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <video
          className="hero-bg-video"
          src="/video.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="hero-popup no-box">
            <div className="hero-title-container">
              <div className="hero-popup-title">
                Securing the Transit and Dynamic Transit Operations Systems of our Nation's Critical Transportation Infrastructure.<br/><br/>
                <span className="hero-subtitle">Cyberthreats - Security Controls - Mitigation Measures</span>
              </div>
            </div>
          <div className="hero-slogan-container">
            <div className="hero-popup-slogan">
            National Transportation Center<br/>
            Morgan State University
            </div>
          </div>
        </div>
      </section>
      <section className="tracr-about-section">
        <div className="section-content">
          <div className="section-text">
            <h2>Project: Transit Security and Dynamic Transit Operations<br/>Cyberthreats & Security Controls</h2>
            <p>
            This research project takes a systematic and comprehensive approach to identifying emerging cyberthreats and recommending effective security controls for Transit Security and Dynamic Transit Operations systems—two essential pillars of the nation's transportation infrastructure. The study employs an adaptive methodology that integrates the strategic, high-level guidance of the National Institute of Standards and Technology (NIST) with the tactical, detailed insights of the MITRE ATT&CK Framework.
            </p>
            <p>
            By combining these complementary frameworks, the project provides cybersecurity professionals, practitioners, and researchers with a structured pathway to:
            </p>
            <p>
            •      Systematically identify current and emerging cyberthreats,<br/>
            •      Map threats to applicable tactics, techniques, and procedures, and<br/>
            •      Recommend actionable security controls and measures to safeguard critical transit systems.
            </p>
            <p>
            This research contributes to strengthening the resilience and security of these two critical transportation infrastructure systems, ensuring safe, reliable, and adaptable transit operations in the face of evolving cyber risks.
            </p>
            <p>
            Please note: This platform provides research-based cybersecurity mappings for the ARC-IT PT03 (Dynamic Transit Operations) and PT05 (Transit Security) service packages. The information and results are intended for educational, research, and analytical purposes only and should not replace organization-specific cybersecurity risk assessments, professional judgment, engineering analysis, or regulatory compliance requirements.
            </p>
          </div>
          <div className="section-image">
            <img src="/TracRLogo.png" alt="About TraCR Foundational Project" className="ntc-image" />
          </div>
        </div>
      </section>
      <section className="mission-section">
        <h2 className="mission-header">Security For Transit & Dynamic Transit Operations Systems</h2>
        <div className="section-content">
          <div className="section-text">
            <Link to="/transit-security" className="image-link">
              <img src="/Transit_S.png" alt="Transit Security" className="section-icon" />
            </Link>
            <h2>Transit Security</h2>
            <div className="content-wrapper">
              <p>
                Transit Security safeguards transportation systems and passengers with advanced technology, real-time monitoring, and rapid threat response.
              </p>
              <p>
                Click to explore Mapping of CyberThreats and Security Controls based on MITRE Attack & NIST
              </p>
            </div>
          </div>
          <div className="section-text">
            <Link to="/dynamic-transit" className="image-link">
              <img src="/Dynamic_T.png" alt="Dynamic Transit Operations" className="section-icon" />
            </Link>
            <h2>Dynamic Transit Operations</h2>
            <div className="content-wrapper">
              <p>
                Dynamic Transit Operations enables seamless, multi-modal travel through advanced scheduling and real-time coordination to optimize routes and enhance rider convenience.
              </p>
              <p>
                Click to explore Mapping of CyberThreats and Security Controls based on MITRE Attack & NIST
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="section-content">
          <div className="section-text">
            <h2>About the National Transportation Center at Morgan State University</h2>
            <p>
              The National Transportation Center (NTC) at Morgan State University is a distinguished research institution focused on transportation and its vital role in human and economic development. Established by Congress in 1991, the NTC addresses social issues related to transportation through robust research and technology transfer, bringing together a wide variety of stakeholders to advance solutions in mobility. As part of the U.S. Department of Transportation's University Transportation Centers Program, the NTC plays a crucial role in advancing transportation technology and expertise in the United States.
            </p>
          </div>
          <div className="section-image">
            <img src="/NTC.png" alt="About NTC" className="ntc-image" />
          </div>
        </div>
      </section>
      <section className="card-section">
        <div className="card-view">
          <h3>Cybersecurity Resources & Tools</h3>
          <p>Access essential cybersecurity resources through the collection below: MITRE ATT&CK Framework for threat intelligence, NIST Framework standards for best practices, TraCR Research on transportation security, and our comprehensive Foundational Project Glossary for key terminology and concepts.</p>
          <div className="card-links">
            <Link to="/cybersecurity-glossary">Foundational Project Glossary</Link>
            <a href="https://attack.mitre.org/" target="_blank" rel="noopener noreferrer">MITRE ATT&CK Framework</a>
            <a href="https://www.nist.gov/privacy-framework/nist-sp-800-53" target="_blank" rel="noopener noreferrer">NIST Framework</a>
            <a href="https://www.clemson.edu/cecas/tracr/research/projects/" target="_blank" rel="noopener noreferrer">TraCR Research</a>
          
          </div>
        </div>
      </section>
      {/* Footer removed: now included globally in App.js */}
    </div>
  );
}

export default Home;
